var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackCircleI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tooltip"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 10,
    cy: 10,
    r: 8,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10 13.3335V10.0002M10 6.66683H10.0083",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCircleI);
export default __webpack_public_path__ + "static/media/black-circle-i.7ab8173c746b5e7bbf929646345d9bc7.svg";
export { ForwardRef as ReactComponent };